import axios from 'axios';
import cookie from 'cookie-machine';
import { func } from 'prop-types';
import { stringify } from 'query-string';
import React from 'react';
import { tabNamesMap } from '../components/TabNamesMap';
import * as utils from '../utils/util';
import { decodeToken } from '../utils/util';
import { tokenExpired } from '../utils/util';
import { convertDate } from '../utils/util';
import { oktaAuth } from 'oktaConfig';

const FileSaver = require('file-saver');

export const REQUEST_TIMEOUT = 10000;

const getQueryString = (qs) => (qs ? `?${stringify(qs)}` : '');

export async function post(url, qs, body) {
  const token = await oktaAuth.getAccessToken();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    }
  };

  return axios
    .post(`/api/${url}${getQueryString(qs)}`, body, config)
    .then((res) => res.data)
    .catch((error) => {
      if (error.response && error.response.data) {
        return Promise.reject(error.response.data);
      }
      return Promise.reject(error);
    });
}

export async function get(url, qs) {
  const token = await oktaAuth.getAccessToken();

  const headers = {
    'Content-Type': 'application/json'
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  try {
    const response = await axios.get(`/api/${url}${getQueryString(qs)}`, { headers });
    return response.data;
  } catch (err) {
    return Promise.reject(err);
  }
}


export async function postExcel(url, qs, project) {
  const token = await oktaAuth.getAccessToken();

  const config = {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    }
  };

  return axios
    .post(`/api/${url}${getQueryString(qs)}`, project, config)
    .then((response) => {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8',
      });
      const filename = (project.projectStatus !== ''
          ? tabNamesMap[project.projectStatus]
          : 'All_Projects') + '.xlsx';
      FileSaver.saveAs(blob, filename);
    })
    .catch((error) => (error.response?.data ? error.response.data : null));
}

export async function postAssetExcel(url, station, qs, body) {
  const token = await oktaAuth.getAccessToken();

  const config = {
    responseType: 'arraybuffer',
    headers: {
      'Authorization': token ? `Bearer ${token}` : ''
    }
  };

  return axios
    .post(`/api/${url}${getQueryString(qs)}`, body, config)
    .then((response) => {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8',
      });
      FileSaver.saveAs(blob, 'AssetSummary_' + station + '.xlsx');
    })
    .catch((error) => (error.response?.data ? error.response.data : null));
}
// for ips data tracker
export async function postIpsAssetExcel(url, station, fileStartingName, qs, body) {
  const token = await oktaAuth.getAccessToken();

  const config = {
    responseType: 'arraybuffer',
    headers: {
      'Authorization': token ? `Bearer ${token}` : '',
      'Content-Type': 'application/json'
    }
  };

  return axios
    .post(`/api/${url}${getQueryString(qs)}`, body, config)
    .then((response) => {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8',
      });
      FileSaver.saveAs(blob, fileStartingName + station + '.xlsx');
    })
    .catch((error) => {
      return error.response && error.response.data ? error.response.data : Promise.reject(error);
    });
}
// for fmp data tracker
export async function postFmpAssetExcel(url, station,fileStartingName, qs, body) {
 const token = await oktaAuth.getAccessToken();
 const config = {
  responseType: 'arraybuffer',
    headers: {
      'Authorization': token ? `Bearer ${token}` : '',
      'Content-Type': 'application/json',
    }
  };
 return axios
    .post(`/api/${url}${getQueryString(qs)}`, body, config)
    .then((response) => {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8',
      });
      FileSaver.saveAs(blob, fileStartingName + station + '.xlsx');
    })
    .catch((error) => {
      return (error.response.data ? error.response.data : null);
    });
}

export function getProject(id, qs = {}) {
  return get(`projects/${id}`, qs);
}
export function getDuplicateProjects(id) {
  return get(`projects/${id}/duplicates`);
}
export function updateProject(project) {
  let updateProjectRequest = {};
  updateProjectRequest.project = project;
  return post(`projects/${project.id}`, '', updateProjectRequest);
}

export function updateProjectDetails(project) {
  let updateProjectRequest = {};
  updateProjectRequest.project = project;
  return post(`updateprojectdetails/${project.id}`, '', updateProjectRequest);
}

export function updateProjectDetailsHazardousMaterials(project, selectedHazardous) {
  let updateProjectRequest = {};
  updateProjectRequest.project = project;
  updateProjectRequest.selectedHazardous = selectedHazardous;
  return post(`updateprojectdetailsmaterials/${project.id}`, '', updateProjectRequest);
}

export function getProjectsHazardous(id, bpidParam) {
  console.log(bpidParam)
  let qs = { bpid: bpidParam };
  return  get(`projectsHazardous/${id}`, qs);
}

export function updateProjectCIPRemovalDetails(project, taskType) {
  let updateProjectRequest = {};
  updateProjectRequest.project = project;
  return post(
    `updateprojectdetails/${project.id}/${taskType}`,
    '',
    updateProjectRequest
  );
}

export async function signedProjectTasks(projectId, taskType, qs = {}) {
  return get(`projects/${projectId}/tasks/${taskType}`, qs);
}

export function mergeProjects(mergeProjectRequest) {
  return post(`projects/merge`, '', mergeProjectRequest);
}

export async function getQuickProjects(qs = {}) {
  let projectsResponse = await get(`quickprojects`, qs);
  return projectsResponse ? projectsResponse.projects : [];
}

export async function getProjects(qs = {}) {
  let projectsResponse = await get(`projects`, qs);
  return projectsResponse ? projectsResponse.projects : [];
}

export async function getProjectAssets(projectId, qs = {}) {
  let projectsResponse = await get(`projects/${projectId}/assets`, qs);
  return projectsResponse ? projectsResponse.assets : [];
}

export async function getAllSections(projectId, qs = {}) {
  let checkListSectionsResponse = await get(
    `projects/${projectId}/checklists`,
    qs
  );
  return checkListSectionsResponse
    ? checkListSectionsResponse.checkListSections
    : [];
}

export async function getAssetsBySectionId(request, qs = {}) {
  let assetsResponse = await get(
    `projects/${request.projectId}/checklists/${request.sectionId}/assets`,
    qs
  );
  return assetsResponse ? assetsResponse.assets : [];
}

export async function getNotifications(qs = {}) {
  let response = await get(`user/notifications/`, qs);
  return response ? response.notifications : [];
}

export async function getMemberNotifications(qs = {}) {
  let response = await get(`user/membernotifications/`, qs);
  return response ? response : [];
}

export async function deleteMemberNotifications(ids, qs = {}) {
  let response = await post(`user/deletemembernotification`, qs, ids);
  return response;
}

export async function getUserEnvironment(qs = {}) {
  let response = await get(`user/environment/`, qs);
  return response;
}

export async function getAllIpsLocations(projectId, qs = {}) {
  let ipsLocationsResponse = await get(
    `projects/${projectId}/ipslocations`,
    qs
  );

  return ipsLocationsResponse ? ipsLocationsResponse.ipsLocations : [];
}

export async function getAssetsByIpsLocationId(request, qs = {}) {
  let assetsResponse = await get(
    `projects/${request.projectId}/ipslocations/${request.ipsLocationId}/assets`,
    qs
  );
  return assetsResponse ? assetsResponse.assets : [];
}

export function getOutages(bpid) {
  return get(`outages/${bpid}`);
}

export async function getTeamMembers(projectId, qs = {}) {
  let response = await get(`projects/team/${projectId}`, qs);
  return response ? response.data : [];
}

export async function getTeamDtailss(projectId, qs = {}) {
  let response = await get(`projects/${projectId}/team`, qs);
  return response ? response.data : [];
}

export async function getTeamRoleMembers(projectId, qs = {}) {
  let response = await get(`projects/${projectId}/teamroles`, qs);
  return response ? response.data : [];
}
export async function getTeamDetails(projectInfo, qs = {}) {
  let response = await post(`ipsprojects/team`, qs,projectInfo);

  return response ? response.data : [];
}
// ips data tracker team & asset integr
export async function getIpsTeamMembers(bpid, qs = {}) {
  let response = await get(`ipsprojects/team/${bpid}`, qs);
  return response ? response.data : [];
}

export async function getIpsTeamRoleMembers(projectInfo, qs = {}) {
  let response = await post(`ipsprojects/teamroles`, qs, projectInfo);
  
  return response ? response.data : [];
}

export async function getIPSProject(projectInfo,qs = {}) {
  // let projectResponse = await get(`ipsprojects/${bpid}`);
  let projectResponse = await post(`ipsprojects/details`, {}, projectInfo);
  
  return projectResponse && projectResponse ? projectResponse.data : []
  
  
}

export async function getFMPProject(projectInfo,qs = {}) {
  let projectResponse = await post(`fmpprojects/details`, {}, projectInfo);
  
  return projectResponse && projectResponse ? projectResponse.data : []
  
}

export async function updateFMPProjectDetails(field) {
  let response = await post(`fmpprojects/detailupdate`, {}, field);

  return response ? response.data : [];
}

export async function getTrackersByDiscipline(projectInfo,qs = {}) {
  let projectResponse = await post(`fmpprojects/trackersByDiscipline`, {}, projectInfo);
  
  return projectResponse && projectResponse ? projectResponse.data : []
  
}

export async function getLCARACTStatus(projectInfo,qs = {}) {
  let projectResponse = await post(`fmpprojects/lcarcaStatus`, {}, projectInfo);
  
  return projectResponse && projectResponse ? projectResponse.data : []
  
}

export async function getAllDropDownOptions(bpid, qs = {}) {
  let allDropDownResponse = await get(`ipsprojects/statusvalues`);
  return allDropDownResponse && allDropDownResponse ? allDropDownResponse : []
}
export async function getIPSProjects(qs = {}) {
  let projectsResponse = await post(`ipsprojects`, qs);
  return projectsResponse ? projectsResponse.ipsprojects : [];
}
// for IPS DATA Tracker Project Status Update
export async function updateDataTrackerProject(projectInfo) {
  const response = await  post(`ipsprojects/changestatus`, '', projectInfo);
  return response ? response.data : [];
}
export async function addNewPhaseToProject(projectInfo) {
  const response = await  post(`ipsprojects/addphase`, '', projectInfo);
  return response ? response.data : [];
}
export async function removePhaseFromProject(projectInfo) {
  const response = await  post(`ipsprojects/deletephase`, '', projectInfo);
  return response ? response.data : [];
}
// From IPS PENDING TAB TO START IPS DATA TRACKER
export async function startIPSProject(projectInfo) {
  const response = await  post(`ipsprojects/addnew`, '', projectInfo);
  return response ? response : [];
}
// From FMP PENDING TAB TO START FMP TRACKER
export async function startFMPProject(projectInfo) {
  const response = await  post(`fmpprojects/addnew`, '', projectInfo);
  return response ? response : [];
}
export async function getIPSProjectAssets(projectInfo, qs = {}) {
  let projectsResponse = await post(`ipsprojects/assets`, qs, projectInfo);
  
  return projectsResponse && projectsResponse.data ? projectsResponse.data : [];
}
export async function getFmpAssets_SE(projectInfo, qs = {}) {
  let projectsResponse = await post(`fmpprojects/fmpSEAssets`, qs, projectInfo);

  return projectsResponse && projectsResponse.data ? projectsResponse.data : [];
}
export async function saveFmpAssets(projectInfo, qs = {}) {
  let projectsResponse = await post(`fmpprojects/fmpAsset`, qs, projectInfo);

  return projectsResponse && projectsResponse.data ? projectsResponse.data : [];
}
export async function getFmpAssets_PCE(projectInfo, qs = {}) {
  let projectsResponse = await post(`fmpprojects/fmpPCEAssets`, qs, projectInfo);

  return projectsResponse && projectsResponse.data ? projectsResponse.data : [];
}
export async function getFmpErrors(qs = {}) {
  let projectsResponse = await post(`fmpprojects/fmpErrors`, qs);

  return projectsResponse && projectsResponse.data ? projectsResponse.data : [];
}
export async function getIPSProjectAssetsRemoval(projectInfo, qs = {}) {
  let projectsResponse = await post(`ipsprojects/removals`, qs, projectInfo);
  
  return projectsResponse && projectsResponse.data ? projectsResponse.data : [];
}
export function deleteIPSProjectAsset(assetId) {
  let asset = {
    assetId: assetId,
  };
  return post(`deleteIpsProjectAsset`, '', asset);
}

export async function getPreforms(projectId) {
  let preformsResponse = await get(`projects/${projectId}/preforms`, {});
  return preformsResponse ? preformsResponse.preEnergizations : [];
}

// export function getIPSTasksByAsset(assetId) {
//     let qs = {isDesktop: 'Y'};
//     return get(`assets/${assetId}/tasksByType`, qs)
// }

// export async function updateTasks(tasks) {
//     return post(`tasks/update`, {}, { tasks })
// }

// export function getProjectTasksByProjectId(bpid) {
//     let qs = {isDesktop: 'Y'};
//     return get(`ipsprojecttasks/${bpid}/tasksByType`, qs)
// }

// export function updateProjectTasks(tasks) {
//     return post(`ipsprojecttasks/update`, {}, { tasks })
// }
// export async function getIPSAssets(bpid, qs = {}) {
//     let projectsResponse = await get(`ipsprojects/${bpid}/assets`, qs);
//     return projectsResponse ? projectsResponse.assets : [];
// }
export function addOrEditIpsTeamMember(
  projectInfo,
  userId,
  editRoles,
  otherRoleId,
  user
) {
  let team = {
    bpid: projectInfo.bpid,
    workOrder: projectInfo.workOrder,
    stationName:projectInfo.stationName,
    userId: userId,
    userRoles: editRoles,
    otherRoleId: otherRoleId,
  };
  let request = {};
  request.team = team;
  request.user = user;
  request.requestType = projectInfo.fmpId
  return post(`addIPSTeamMember`, '', request);
}
export async function deleteIpsUserFromTeam(projectInfo, userId) {
  let team = {
    bpid: projectInfo.bpid,
    workOrder: projectInfo.workOrder,
    stationName: projectInfo.stationName,
    userId: userId,
  };
  let response = await post(`deleteIPSTeamMember`, '', team);
  return response;
}

export function updateIpsTeamMemberDetails(projectInfo, userId, user) {
  let team = {
    bpid: projectInfo.bpid,
    workOrder:projectInfo.workOrder,
    stationName:projectInfo.stationName,
    userId: userId,
  };
  let request = {};
  request.team = team;
  request.user = user;
  return post(`updateIPSTeamMemberDetails`, '', request);
}

export async function getNonTeamUsers(userIds) {
  let userRequest = {
    userIds: userIds,
  };
  let response = await post(`users`, '', userRequest);
  return response ? response.users : [];
}

export async function getUser(searchString) {
  let userRequest = {
    searchString: searchString,
  };
  let response = await post(`user/bolt`, '', userRequest);
  return response ? response.users : [];
}
export async function getSelectedUser(userId, qs = {}) {
  let response = await post(`selectedUser/${userId}`, qs);
  return response;
}

export async function getTFSPCAreas(qs = {}) {
  return await get(`pcareas`, qs);
}

export async function getTfStationAreas(qs = {}) {
  return await get(`stationareas`, qs);
}

export async function getStationRegions(qs = {}) {
  return await get(`regions`, qs);
}

export async function getBPIDs(qs = {}) {
  return await get(`bpids`, qs);
}

export async function getMPIDs(qs = {}) {
  return await get(`mpids`, qs);
}

export async function getAllProjectWOs(qs = {}) {
  return await get(`workorders`, qs);
}

export async function getReasonCodes(qs = {}) {
  return await get(`reasoncodes`, qs);
}

export async function getPCContractors(qs = {}) {
  return await get(`pccontractors`, qs);
}

export function getSuggestions(qs = {}) {
  return get(`suggestions`, qs);
}

export function addEditTeamMember(
  projectId,
  userId,
  editRoles,
  otherRoleId,
  user
) {
  let team = {
    projectId: projectId,
    userId: userId,
    userRoles: editRoles,
    otherRoleId: otherRoleId,
  };
  let request = {};
  request.team = team;
  request.user = user?.user || user;
  return post(`addTeamMember`, '', request);
}

export function updateTeamMemberDetails(projectId, userId, user) {
  let team = {
    projectId: projectId,
    userId: userId,
  };
  let request = {};
  request.team = team;
  request.user = user;
  return post(`updateTeamMemberDetails`, '', request);
}

export async function getNonCheckListUser(user) {
  let response = await post(`verifyNonChecklistUser`, '', user);
  return response;
}

export async function deleteUserFromTeam(projectId, userId) {
  let team = {
    projectId: projectId,
    userId: userId,
  };
  let response = await post(`deleteTeamMember`, '', team);
  return response;
}

export function deleteProjectAsset(assetId) {
  let asset = {
    assetId: assetId,
  };
  return post(`deleteProjectAsset`, '', asset);
}

export function getTasksByAsset(assetId) {
  let qs = { isDesktop: 'Y' };
  return get(`assets/${assetId}/tasksByType`, qs);
}

export function getTaskByTaskId(assetId, taskId) {
  let qs = { isDesktop: 'Y' };
  return get(`assets/${assetId}/taskById/${taskId}`, qs);
}

export function getTasksByAttribute(assetId) {
  let qs = { isDesktop: 'Y' };
  return get(`assets/${assetId}/tasksByAttribute`, qs);
}

export async function updateTasks(tasks) {
  return post(`tasks/update`, {}, { tasks });
}

export function getProjectTasksByProjectId(projectId) {
  let qs = { isDesktop: 'Y' };
  return get(`projecttasks/${projectId}/tasksByType`, qs);
}

export function updateProjectTasks(tasks) {
  return post(`projecttasks/update`, {}, { tasks });
}

export function validateProjectClose(projectId) {
  return get(`active/${projectId}/validateProjectClose`);
}

export async function getStations(qs = {}) {
  let stationsResponse = await get(`stations`, qs);
  return stationsResponse ? stationsResponse.stations : [];
}
export async function getIpsStations(qs = {}) {
  let ipsStationsResponse = await get(`ipsstations`, qs);
  return ipsStationsResponse ? ipsStationsResponse.stations : [];
}

export async function getMeetingNotesByProjectId(projectId) {
  let response = await get(`notes/${projectId}`);
  return response ? response.meetingNotesList : [];
}

export async function getJobJournalsByProjectId(projectId) {
  let response = await get(`projects/${projectId}/jobjournals`);
  return response ? response.jobJournals : [];
}

export async function getJournal(projectId, journalId) {
  let response = await get(`jobjournals/${projectId}/${journalId}`);
  return response ? response.jobJournal : {};
}

export async function getAttachments(journalId) {
  let response = await get(`attachments/${journalId}`);
  return response ? response.jobJournalAttachments : {};
}

export function deleteJobJournal(jobjournalId) {
  return get(`projects/jobjournal/${jobjournalId}/delete`, {});
}

export async function getJobJournalCommentsById(projectId, formId) {
  let response = await get(
    `projects/${projectId}/jobJournals/${formId}/comments`
  );
  return response ? response.jobJournalComments : [];
}

export function addJobJournalComment(comments, projectId, formId) {
  return post(
    `projects/${projectId}/jobJournal/${formId}/newComments`,
    {},
    { comments }
  );
}

export async function getJobJournalCategories(qs = {}) {
  let response = await get(`jobJournalCategories`);
  return response ? response.jobJournalCategories : [];
}
export async function getProjectJournalAssets(projectId) {
  let response = await get(`projects/${projectId}/jobjournal/assets`);
  return response ? response.jobJournalAssetsMappings: [];
}
export async function getNote(projectId, noteId) {
  let response = await get(`notes/${projectId}/${noteId}`);
  return response ? response.note : {};
}

export async function getMeetingTypes(qs = {}) {
  let response = await get(`meetingTypes`);
  return response ? response.meetingTypes : [];
}

export function updateNotes(meetingNote) {
  return post(`/meetingnotes/update`, {}, { meetingNote });
}

export function deleteNotes(projectId, noteId) {
  return post(`/meetingnotes/delete`, {}, { projectId, noteId });
}

export async function getPdfReport(projectId, requestDate) {
  let response = await get(`/pdfReport/${projectId}/${requestDate}`);
  return response;
}

export async function updateUser() {
  await get(`user/update`);
}

export async function updateUserProfile(userProfile) {
  let response = await post(`user/updateprofile`, '', userProfile);
  return response.data;
}

let userProfile = null;

export async function getUserProfile() {
  if (userProfile !== null) return userProfile;
  let response = await get(`user/profile`);
  userProfile = response.data;
  return userProfile;
}
// FOR CHECKLIST
export async function getUserProjects() {
  let response = await get(`user/projects`);
  return response.data;
}
// FOR IPSDT PROJECTS
export async function getIPSDTUserProjects() {
  let response = await get(`user/ipsprojects`);
  
  return response.data;
}
// for TCL Project comments to get
export async function getComments(projectId) {
  let response = await get(`projects/${projectId}/comments`);
  return response ? response.comments : [];
}

// for IPS DATA TRACKER card view and single COMMENTS
export async function getCommentsIpsDT(projectInfo, commentGrp) {
  let response = await post(`ipsprojects/comments/${commentGrp}`,{},projectInfo);

  return response ? response.data : [];
}

// FOR IPS DATA TRACKER ALL SECTION PROJECT COMMENTS
export async function getAllCommentsIpsDT(projectInfo) {
  let response = await post(`ipsprojects/comments`,{},projectInfo);

  return response ? response.data : [];
}

// For TCL Project Add  comments
export function addnewComment(comments, projectId) {
  return post(`projects/${projectId}/newComment`, {}, { comments });
}
// For IPS DATA TRACKER COMMENTS
export  async function addnewCommentIpsDT(comments) {
  let response = await  post(`ipsprojects/newComment`, {}, comments);
  return response ? response.data : [];
}

export function undoProjectStatus(project) {
  return post(`projects/${project.id}/undo`, '');
}

export function undoNAProjectStatus(project) {
  return post(`projects/${project.id}/undona`, '');
}
// FOR TCL PROJECTS
export function excelFileDownload(project, qs = {}) {
  return postExcel(`projects/download`, '', project);
}

// FOR IPSDATA TRACKER  PROJECTS
export function IPSDTexcelFileDownload(projectStatus, qs = {}) {
  return postExcel(`ipsprojects/download`, '', projectStatus);
}
// FOR UPDATING IPS DATA TRACKER PROJECT DETAILS STATUS

export async function updateIpsDTProjectDetail(field) {
  let response = await post(`ipsprojects/detailupdate`, {}, field);

  return response ? response.data : [];
}

export function assetExcelDownload(projectId, station, qs = {}) {
  return postAssetExcel(`projects/${projectId}/download`, station, {});
}
export function ipsAssetInstallationExcelDownload(projectInfo, station, fileStartingName,qs = {}) {
  return postIpsAssetExcel(`ipsprojects/assets/download`, station, fileStartingName, {},projectInfo);
}
export function ipsAssetRemovalExcelDownload(projectInfo, station,fileStartingName, qs = {}) {
  return postIpsAssetExcel(`ipsprojects/removals/download`, station,fileStartingName, {},projectInfo);
}
export function fmpAssetSEReviewExcelDownload(projectInfo, station,fileStartingName, qs = {}) {
  return postFmpAssetExcel(`fmpprojects/fmpAssetSE/download`, station,fileStartingName, {},projectInfo);
}
export function fmpAssetPCEReviewExcelDownload(projectInfo, station,fileStartingName, qs = {}) {
  return postFmpAssetExcel(`fmpprojects/fmpAssetPCE/download`, station,fileStartingName, {},projectInfo);
}
// FOR FMP TRACKER  PROJECTS
export function FMPexcelFileDownload(projectStatus, qs = {}) {
  return postExcel(`fmpprojects/download`, '', projectStatus);
}

// for FMP TRACKER Tracks COMMENTS
export async function getCommentsByFmpTracks(fmpId, commentGrp) {
  console.log("Grabbing Comments by FMP: " + fmpId);
  let response = await post(`fmpprojects/comments/${fmpId}/${commentGrp}`,{});

  return response ? response.data : [];
}
export  async function addnewCommentFMPTracker(comments) {
  let response = await  post(`fmpprojects/newComment`, {}, comments);
  return response ? response.data : [];
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export async function getUserRoles(qs = {}) {
  return await get(`roles`, qs);
}
export async function addUserRole(role) {
  let response = await post(`role/new`, {},  role );
  return response;
}
export async function editUserRole(role) {
  let response = await post(`role/${role.roleId}`, {},  role );
  return response;
}
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export async function addOtherRole(otherRoleName) {
  let response = await post(`otherroles/new`, {}, { otherRoleName });
  return response;
}
export async function editOtherRole(otherRole) {
  let request = {};
  request.otherRole = otherRole;
  let response = await post(`otherroles/${otherRole.roleId}`, {}, request);
  return response;
}
export async function deleteOtherRole(roleId) {
  let response = await post(`otherroles/${roleId}/delete`, {}, { roleId });
  return response;
}
export async function getOtherRoles() {
  return await get(`otherroles`, '');
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export async function addPCContractor(pcContractor) {
  let response = await post(`pccontractor/new`, {}, { pcContractor });
  return response;
}
export async function editPCContractor(pcContractor) {
  let response = await post(
    `pccontractor/${pcContractor.id}`,
    {},
    pcContractor
  );
  return response;
}
export async function deletePCContractor(id) {
  let response = await post(`pccontractor/${id}/delete`, {}, { id });
  return response;
}
/////////////////////////////////////////////////////////////////////////////////////////////////////////
export async function getTaskLinks() {
  return await get(`tasklinks`, '');
}
export async function getTaskLinksHost() {
  return await get(`tasklinkshost`, '');
}
export async function addTaskLink(link) {
  let response = await post(`tasklinks/new`, {},  link );
  return response;
}
export async function editTaskLink(link) {
  let response = await post(`tasklinks/${link.linkId}`, {},  link );
  return response;
}
//////////////////////////////////////////////////////////////////////////////////////////////
export async function getChecklistRevisions() {
  return await get(`checklistrevisions`, '');
}
export async function getChecklistRevision(checklistId, revisionNo) {
  return await get(`checklistrevision/${checklistId}/rev/${revisionNo}`, '');
}
export async function addChecklistRevision(checklist) {
  let response = await post(`checklistrevisions/new`, {},  checklist );
  return response;
}
export async function editChecklistRevision(checklist) {
  let response = await post(`checklistrevision/${checklist.id.checklistId}/rev/${checklist.id.revisionNo}/edit`, {},  checklist );
  return response;
}
export async function activateChecklistRevision(checklistId, revisionNo) {
  let response = await post(`checklistrevision/${checklistId}/rev/${revisionNo}/activate`, {});
  return response;
}
export async function getTaskActions() {
  return await get(`taskactions`, '');
}
export async function getTaskTypes() {
  return await get(`tasktypes`, '');
}
export async function editTaskType(type) {
  let response = await post(`tasktypes/edit`, {},  type );
  return response;
}

export async function downloadChecklistRevision(checklistId, revisionNo, name) {
  let response = await postRevisionExcel(`checklistrevision/${checklistId}/rev/${revisionNo}/download`, name);
  return response;
}
export async function downloadAllChecklistRevisions() {
  let response = await postRevisionExcel(`checklistrevision/download`, 'ALL');
  return response;
}

export async function postRevisionExcel(url, name, qs, body) {
  await isUserTokenValid();
  axios.interceptors.request.use(
      (config) => {
        const token = cookie.get('aep');
        if (token !== null) {
          config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
  );
  return axios
      .post(`/api/${url}${getQueryString(qs)}`, body, {
        responseType: 'arraybuffer',
      })
      .then((response) => {
        var blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8',
        });
        FileSaver.saveAs(blob, 'Checklist_' + name + '.xlsx');
      })
      .catch((error) => (error.response.data ? error.response.data : null));
}

export async function updateFmpTrackerStatus(project) {
  let response = await post(`fmpprojects/fmpTrackerStatus`, {}, project);

  return response ? response.data : [];
}

export async function saveTrackerTrackAudit(projectInfo, project, rowData) {
  let extraDtaInfo = {
     lrcarcaStatus: rowData,
     project: project
  }
  
  let projectData = projectInfo;
  projectData.extraData = [extraDtaInfo];
  let response = await post(`fmpprojects/saveTrackerTrackAudit`, {}, projectData);

  return response ? response.data : [];
}

//////////////////////////////////////////////////////////////////////////////////////////////
export async function deleteIPSDataTracker(project) {
  const response = await post(`ipsprojects/delete`, {}, project);
  return response
}

export async function deleteFMPTracker(project) {
  const response = await post(`fmpprojects/delete`, {}, project);
  return response
}
// refresh token
// const needTokenRefresh = () => {
//     const accessToken = cookie.get('aep');
//     const decodedAccessToken = decodeToken(accessToken);
//
//     const diff = decodedAccessToken.exp - decodedAccessToken.iat;
//     const refreshTime = convertDate(decodedAccessToken.iat + diff / 2);
//     console.log('refresh time::::', refreshTime);
//     return new Date() > refreshTime;
// };

//const logout = () => utils.goToUrl(utils.getOriginIfLocal() + '/logout');
// Inside HeaderNav or wherever the logout button is

const logout = async () => {
  // This clears the Okta session AND the local tokens
  await oktaAuth.signOut({ postLogoutRedirectUri: window.location.origin });
};
const isUserTokenValid = async () => {
  if (tokenExpired()) {
    return logout();
  }
};

///////////Conductor Work Release 2//////////////////////

export async function getAutoDeskToken() {
  if(await isUserTokenValid()){
    let response = await get(`autodesk/auth/token`);
      return response.access_token;
  }
}